module.exports = __webpack_public_path__ + "img/user_avatar.679b945a.png";